// 不同环境下的前端请求路径配置表
// 开发环境启动: yarn serve
// 生产环境打包: yarn build
// uat 环境: yarn uat-build
const URLs = {
  development: '',
  uat: 'http://192.168.4.231:8008/',
  production: 'http://192.168.4.231:8081/',

};
export default URLs[process.env.NODE_ENV];
